// @component ./EditColor.tsx
export { default as Color } from './Color'

// @component ./EditNumber.tsx
export { default as Number } from './Number'

// @component ./EditView.tsx
export { default as View } from './View'

// @component ./EditViewOnline.tsx
export { default as ViewOnline } from './ViewOnline'
